import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-0 mb-12">
          <div className="lg:w-1/2">
            <p className="text-sm text-foreground-400 font-semibold uppercase tracking-wider mb-3">
              {t('categories.title1', 'Все товарные')}
            </p>
            <h2 className="text-3xl md:text-5xl font-heading font-bold italic text-foreground-950">
              {t('categories.title2', 'категории')}
            </h2>
          </div>
          <div className="lg:w-1/2 flex items-end">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              {t('categories.description', 'Выбирайте из широкого ассортимента товаров.')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.nameEn}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center h-[70px] px-6 rounded-2xl bg-background-100 hover:bg-foreground-950 transition-all duration-300 cursor-pointer"
            >
              <span className="text-base font-semibold text-foreground-900 group-hover:text-background-50 transition-colors duration-300 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="ml-auto w-5 h-5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-background-50">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}